import React from "react";
import { RouteObject } from "react-router";
import { LoggedInProps } from "modules/common/components/routing/AnonymousRoute";
import { ProtectedRoute } from "modules/common/components/routing/ProtectedRoute";
import { routes } from "modules/common/routes";
import OrderDetailsTabsPage from "./details/OrderDetailsTabsPage";
import { MainTabsPage } from "modules/main/components/MainTabsPage";
import { ApplicationStoreType } from "modules/root/models/store";

export const buildRoutes = ({ store, loggedIn, baseUrl }: RoutesProps): RouteObject[] => [
  {
    path: `${routes.orders.manage}/*`,
    element: (
      <ProtectedRoute loggedIn={loggedIn}>
        <MainTabsPage
          access={store.session.access}
          table={store.detailedOrders}
          shortOrders={store.shortOrders}
          session={store.session}
          dashboard={store.dashboard}
          accounts={store.moneyAccounts}
        />
      </ProtectedRoute>
    ),
  },
  {
    path: `${routes.orders.path}/*`,
    element: (
      <ProtectedRoute loggedIn={loggedIn}>
        <OrderDetailsTabsPage
          baseUrl={baseUrl}
          store={store.orders}
          settings={store.settings}
          session={store.session}
          clientStore={store.workResult}
        />
      </ProtectedRoute>
    ),
  },
];

interface RoutesProps extends LoggedInProps {
  baseUrl: string;
  store: ApplicationStoreType;
}
